// extracted by mini-css-extract-plugin
module.exports = {"entity_header":"entity-header_entity_header__Zy_pb"};